// extracted by mini-css-extract-plugin
module.exports = {"Markings":"Markings_Markings__31iuZ","tabListContainer":"Markings_tabListContainer__xwkLB","likeAnimation":"Markings_likeAnimation__1yaAj"};